import { Component, Input } from '@angular/core';

@Component({
  selector: 'z-cart-indicator',
  standalone: false,
  templateUrl: './cart-indicator.component.html',
  styleUrls: ['./cart-indicator.component.scss']
})
export class CartIndicatorComponent {

  @Input() activeStep: number;
  @Input() finishedStep = 0;

  shoppingCartSteps = [
    {
      number: 1,
      titleKey: 'Labels.ShoppingCart.Step1'
    },
    {
      number: 2,
      titleKey: 'Labels.ShoppingCart.Step2'
    },
    {
      number: 3,
      titleKey: 'Labels.ShoppingCart.Step3'
    }
  ];

}
